import { EyeFilled, EyeInvisibleFilled } from "@ant-design/icons";
import { Button, Form, Input } from "antd";
import WelcomeSplash from "./WelcomeSplash";
import {DsquaresLogo} from "src/assets/Icons";
import { useLazyGetTokenQuery } from "src/store/slices/authentication/Token.api";
import { useDispatch } from "react-redux";
import { login } from "src/store/slices/authentication/auth.slice";
import { useTranslation } from "react-i18next";

export default function Login() {
  const { t } = useTranslation();
  const [request, { isFetching }] = useLazyGetTokenQuery();
  const dispatch = useDispatch();

  const onFinish = (values: { tenantId: string; userName: string; password: string }) => {
    request(values).then((res) => {
      if (res.data) dispatch(login(res.data));
    });
  };

  return (
    <div className="flex h-screen bg-background-default">
      <WelcomeSplash />
      <div className="relative flex w-full flex-col items-center justify-center px-6 lg:w-2/5">
        <div className="absolute start-8 top-8 lg:hidden">
          <DsquaresLogo className="w-auto flex-shrink-0" />
        </div>

        <div className="w-full max-w-[22rem]">
          <div className="mb-10">
            <h1 className="text-3xl font-semibold text-font-active">
              {t("Login.welcomeBack")}
            </h1>
            <p className="mt-2 text-sm text-font-subtle">
              {t("Login.subtitle")}
            </p>
          </div>

          <Form layout="vertical" initialValues={{ rememberMe: false }} onFinish={onFinish} className="flex flex-col gap-1">
            <Form.Item
              name="tenantId"
              label={
                <span className="text-sm font-medium text-font-default">
                  {t("Login.tenantId")}
                </span>
              }
              rules={[{ required: true, message: t("Login.tenantIdRequired") }]}
              className="mb-4"
            >
              <Input id="tenantId" className="input-field-ant" placeholder={t("Login.tenantIdPlaceholder")} size="large" />
            </Form.Item>
            <Form.Item
              name="userName"
              label={
                <span className="text-sm font-medium text-font-default">
                  {t("Login.username")}
                </span>
              }
              rules={[{ required: true, message: t("Login.usernameRequired") }]}
              className="mb-4"
            >
              <Input id="userName" className="input-field-ant" placeholder={t("Login.usernamePlaceholder")} size="large" />
            </Form.Item>

            <Form.Item
              name="password"
              label={
                <span className="text-sm font-medium text-font-default">
                  {t("Login.password")}
                </span>
              }
              rules={[{ required: true, message: t("Login.passwordRequired") }]}
              className="mb-2"
            >
              <Input.Password
                autoComplete="current-password"
                id="password"
                className="input-field-ant"
                placeholder={t("Login.passwordPlaceholder")}
                size="large"
                iconRender={(visible) =>
                  visible ? (
                    <EyeFilled className="text-icon-subtle" style={{ fontSize: "1.25rem" }} />
                  ) : (
                    <EyeInvisibleFilled className="text-icon-subtle" style={{ fontSize: "1.25rem" }} />
                  )
                }
                visibilityToggle
              />
            </Form.Item>

            <Form.Item className="mb-0">
              <Button
                type="primary"
                htmlType="submit"
                className="bg-background-primary! text-font-inverted! font-semibold! w-full"
                size="large"
                loading={isFetching}
                iconPlacement="end"
              >
                {t("Login.signIn")}
              </Button>
            </Form.Item>
          </Form>
        </div>
      </div>
    </div>
  );
}
